import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { ToastrService } from 'ngx-toastr';
import { PowerTransformerService } from '../../../../../services/power-transformer.service';
import { Voltage } from '../../../../../enums/voltage';
import { AssetRating } from '../../../../../models/asset-rating.model';
import { PermissionsService } from '../../../../../services/permissions.service';

@Component({
  selector: 'lib-nec-substation-details-power-transformer',
  standalone: false,
  templateUrl: './nec-substation-details-power-transformer.component.html',
  styleUrls: ['./nec-substation-details-power-transformer.component.scss', '../nec-substation-details.component.scss']
})
export class NecSubstationDetailsPowerTransformerComponent implements OnInit{

  @Input() substationId: any;
  @Input() substationTemplateInstanceId: any;
  @Input() substationVoltage: any;
  @Input() ratingOptions: AssetRating[] = [];
  @Output() openSchematic = new EventEmitter<void>();
  isOpen = false;
  powerTransformers: any[] = []
  selectedPTId: { value: number | null } | null = { value: 0 };
  modalOpened: boolean = false;
 
  constructor(private powerTransformerService: PowerTransformerService,
      private toastr: ToastrService,
      public permissionsService: PermissionsService ){}

  ngOnInit(): void {
    this.getPowerTransformersBySubstationId(this.substationId);
    this.substationVoltage = Voltage[this.substationVoltage as keyof typeof Voltage];
  }

  getPowerTransformersBySubstationId(substationId: number): void {
    this.powerTransformerService.getPowerTransformersBySubstationId(substationId).subscribe({
      next: (response: any) => {
        const responseData = response.body
        if (responseData?.status === 'OK' && responseData?.data) {
          const data = responseData.data;
          this.powerTransformers = data;
        } else{
          this.toastr.error(responseData.message)
        }
      },
      error: () => {
        this.toastr.error('Error occurred while loading Power Transformer data');
      }
    });
  }

  toggleHiddenInfo(id: number){
    if(this.isOpen === false || this.selectedPTId?.value === id || this.selectedPTId?.value === 0)
      this.isOpen = !this.isOpen;
    this.setPTIdValue(id);
  }

  selectPowerTransformer(powerTransformerId: number | null){
    this.isOpen = false;
    this.selectedPTId = { value: powerTransformerId };
    this.modalOpened = true;
  }

  newPowerTransformer(){
    this.openSchematic.emit();
  }

  setPTIdValue(id: number) {
    this.selectedPTId!.value = id;
  }

  reloadList(){
    this.selectedPTId = { value: 0 };
    this.getPowerTransformersBySubstationId(this.substationId);
  }
}
